export const addOrderIdToSession = (id: number): void =>
  sessionStorage.setItem('orderId', id.toString())

export const getOrderIdFromSession = (): string =>
  sessionStorage.getItem('orderId')

export const addAccessTokenToSession = (access_token: string): void =>
  sessionStorage.setItem('accessToken', access_token)

export const getAccessTokenFromSession = (): string =>
  sessionStorage.getItem('accessToken')

export const userHasAuthenticationParams = (): string | null =>
  getAccessTokenFromSession() && getOrderIdFromSession()

export const addModalFlag = (): void =>
  sessionStorage.setItem('removeModal', 'true')

export const getModalFlag = (): string => sessionStorage.getItem('removeModal')

export const removeModalFlag = (): void =>
  sessionStorage.removeItem('removeModal')
